var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6018 1.77342C19.502 0.676374 21.8436 0.678774 23.7415 1.77972L30.621 5.77042L37.5168 9.73288C39.4192 10.826 40.5921 12.8527 40.5921 15.0468V30.9615C40.5921 33.1511 39.4239 35.1744 37.5277 36.2692L23.7379 44.2308C21.8416 45.3256 19.5053 45.3256 17.6091 44.2308L3.81928 36.2692C1.92302 35.1744 0.754883 33.1511 0.754883 30.9615V15.0385C0.754883 12.8489 1.92302 10.8256 3.81928 9.73077L17.6018 1.77342Z",
    fill: "#FFE0A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3701 6.20293L30.3719 6.20395L37.2677 10.1664C39.0148 11.1704 40.0921 13.0317 40.0921 15.0468V30.9615C40.0921 32.9725 39.0192 34.8307 37.2777 35.8362L23.4879 43.7978C21.7463 44.8032 19.6006 44.8032 17.8591 43.7978L4.06928 35.8362C2.32772 34.8307 1.25488 32.9725 1.25488 30.9615V15.0385C1.25488 13.0275 2.32773 11.1693 4.06928 10.1638L17.8518 2.20644C19.5969 1.19889 21.7475 1.20109 23.4906 2.21222L30.3701 6.20293Z",
    stroke: "#E08815",
    strokeOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0756 10.1789L28.0773 10.1799L34.2098 13.7037C35.0058 14.1611 35.4965 15.0091 35.4965 15.9272V30.0768C35.4965 30.993 35.0077 31.8396 34.2143 32.2977L21.9567 39.3746C21.1633 39.8327 20.1858 39.8327 19.3923 39.3746L7.13474 32.2977C6.34131 31.8396 5.85254 30.993 5.85254 30.0768V15.923C5.85254 15.0068 6.34131 14.1603 7.13474 13.7022L19.3887 6.62734C20.1838 6.16832 21.1635 6.16932 21.9576 6.62998L28.0756 10.1789Z",
    stroke: "#E08815",
    strokeOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank1);
export default __webpack_public_path__ + "static/media/rank1.ca43aa552475d462de762b2b1472c2a6.svg";
export { ForwardRef as ReactComponent };